export enum PublicRouteEnum {
    LANDING_PAGE = 1,
    CONTACT_INFO = 2,
    ENTER_INCIDENT_INFO = 3,
    SUBMIT_COMPLAINT = 4,
}

// probably make one for AdminRouteEnum later but may not be needed